// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"J1-z","categoryName":"K1-z","categoryImage":"L1-z","categoryContent":"M1-z","bottomAligned":"N1-z"};